import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import moment from "moment";
import Slider from "react-slick";
import "./style.scss";

import PriceComp from "../../components/PriceComp";
import PopupComp from "../../components/PopupComp";
import { LoadingComp } from "../../components/LoadingComp";

export default class Booking extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
      show_filter: false,
      you_made: [],
      customer_made: [],
      isPopup: false,
      isLoading: true,
      book_id: 0,
      sortBooking: "",
      sortDate: "",
      fromDate: "",
      toDate: "",
      count_approve: 0,
      isPopupStatus: "",
      popupText1: "",
      popupText2: ""
    };
  }

  componentDidMount() {
    this._isMounted = true;

    this.you_made();
    this.customer_made();

    let { hash } = this.props.history.location;
    switch (hash) {
      case "#customer":
        return this.handleChange(2, "#customer");
      default:
        return this.handleChange(1);
    }
  }

  handleChange = (tab, hash = "#") => {
    this.props.history.push(hash);
    this.setState({
      tab
    });
  };

  handleOpenFilter = () => {
    this.setState({
      show_filter: !this.state.show_filter
    });
  };

  you_made = () => {
    let { sortBooking, sortDate, fromDate, toDate } = this.state;
    let _this = this;
    axios
      .get(`${constant.phpHost}action/dashboard.php`, {
        params: {
          todo: "you_made_spaces",
          user_id: this.props.user_id,
          sortBooking: sortBooking,
          sortDate: sortDate,
          fromDate: fromDate,
          toDate: toDate
        }
      })
      .then(function(res) {
        if (_this._isMounted) {
          _this.setState({
            you_made: res.data.spaces,
            isLoading: false
          });
        }
      });
  };

  customer_made = () => {
    let { sortBooking, sortDate, fromDate, toDate } = this.state;
    let _this = this;
    axios
      .get(`${constant.phpHost}action/dashboard.php`, {
        params: {
          todo: "customer_made_spaces",
          user_id: this.props.user_id,
          sortBooking: sortBooking,
          sortDate: sortDate,
          fromDate: fromDate,
          toDate: toDate
        }
      })
      .then(function(res) {
        if (_this._isMounted) {
          _this.setState({
            customer_made: res.data.spaces,
            count_approve: res.data.count_approve,
            isLoading: false
          });
        }
      });
  };

  handlePopup = () => {
    this.setState({
      isPopup: !this.state.isPopup
    });
  };

  handleAction = (status, id, t1 = "", t2 = "") => {
    this.setState({
      isPopup: !this.state.isPopup,
      isPopupStatus: status,
      popupText1: t1,
      popupText2: t2,
      book_id: id
    });
  };

  handleFeedbackLength = e => {
    e.preventDefault();
    let { value } = e.target;
    let maxLength = 250;
    let char_length = document.getElementById("char_length");

    if (value.length > maxLength)
      return (e.target.value = value.substring(0, maxLength));

    return (char_length.innerHTML = maxLength - value.length);
  };

  handleFeedbackSubmit = e => {
    e.preventDefault();

    let _this = this;
    let formData = new FormData(e.target);
    let { hash } = this.props.history.location;

    formData.append("todo", "feedback_for_booking_cancelling");
    formData.append("book_id", this.state.book_id);
    formData.append("user_id", this.props.user_id);
    formData.append("status", 1);

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData)
      .then(response => {
        alert("success");

        _this.setState({
          isPopup: false,
          book_id: 0
        });

        if (hash === "#customer") _this.customer_made();
        else _this.you_made();
      });
  };

  handleFilterChange = (e, field) => {
    e.preventDefault();

    let _this = this;
    let fields = this.state;
    let { hash } = this.props.history.location;

    fields[field] = e.target.value;

    this.setState({ fields });

    if (hash === "#customer") _this.customer_made();
    else _this.you_made();
  };

  handleConfirm = () => {
    let { isPopupStatus, book_id } = this.state;
    let _this = this;
    let { hash } = this.props.history.location;

    let formData = new FormData();
    formData.append("todo", "booking_status_change");
    formData.append("id", book_id);
    formData.append("status", isPopupStatus === "accept" ? "done" : "cancel");
    formData.append("cancel_type", isPopupStatus === "reject" ? 1 : 0);

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "text/plain"
        }
      })
      .then(response => {
        alert("success");

        _this.setState({
          isPopup: false,
          popupText1: "",
          popupText2: "",
          book_id: 0
        });

        if (hash === "#customer") _this.customer_made();
        else _this.you_made();
      });
  };

  // It works above render
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let {
      tab,
      show_filter,
      you_made,
      customer_made,
      isLoading,
      isPopup,
      count_approve,
      isPopupStatus,
      sortDate
    } = this.state;

    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    let listing = (list, i, made) => (
      <div
        id={list.id}
        className={`rows ${
          list.show ? "show" : list.book.cancel_type === 1 ? "hide" : ""
        }`}
        key={i}
      >
        <div className="left">
          <span>#{list.book.id}</span>
          <a href={list.url}>
            <Slider {...settings}>
              {list.images.map((image, i) => (
                <img src={image} alt="" key={i} />
              ))}
            </Slider>
          </a>
        </div>
        <div className="right">
          <div className="content">
            <div>
              <h3>
                <a href={list.url}>{list.title}</a>
              </h3>
              <a href={list.url}>
                <p>
                  <i>Up to </i>
                  <i>
                    {list.space.quantity} {list.space.q_name} |{" "}
                    {list.location.place}
                  </i>
                </p>
              </a>
              <div className="text">
                {made === "you_made" ? (
                  <p>
                    Customer: <span>{list.user.name}</span>
                  </p>
                ) : null}
                <p>
                  Amount:{" "}
                  <span className="price">
                    <PriceComp price={list.book.amount} />
                  </span>
                </p>
              </div>
            </div>

            <div className="bottom">
              <span className="created">
                Created: {moment(list.book.created).format("DD-MM-YYYY H:m:s")}
              </span>
              {made === "you_made" ? (
                <div>
                  {list.book.cancel_request === "" ? (
                    <span
                      onClick={() => this.handleAction("cancel", list.book.id)}
                      className="cancel"
                    >
                      Cancel Booking
                    </span>
                  ) : (
                    <span
                      className={`cancel ${
                        list.book.cancel_request === "Request Rejected"
                          ? "rejected"
                          : list.book.cancel_request === "Request Accepted"
                          ? "accepted"
                          : "processing"
                      }`}
                    >
                      {list.book.cancel_request}
                    </span>
                  )}
                  {list.book.cancel_request !== "Request Accepted" ? (
                    <a
                      href={list.reservation}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view_booking"
                    >
                      View Reservation
                    </a>
                  ) : null}
                </div>
              ) : made === "customer_made" ? (
                list.book.status === "paid" ? (
                  <div>
                    <span
                      className="cancel"
                      onClick={() =>
                        this.handleAction(
                          "reject",
                          list.book.id,
                          "Reject Booking!",
                          "Are you sure want to reject this booking?"
                        )
                      }
                    >
                      Reject Booking
                    </span>
                    <span
                      className="view_booking"
                      onClick={() =>
                        this.handleAction(
                          "accept",
                          list.book.id,
                          "Accept Booking!",
                          "Are you sure want to accept this booking?"
                        )
                      }
                    >
                      Accept Booking
                    </span>
                  </div>
                ) : list.book.cancel_type === 1 ? (
                  <div>
                    <span className="cancel rejected">
                      You Rejected this Booking
                    </span>
                  </div>
                ) : null
              ) : null}
            </div>
          </div>

          <div className="booking_date">
            <div>
              <span>Check in</span>
              <b>{moment(list.book.f_date).format("DD")}</b>
              <span>{moment(list.book.f_date).format("MMM YYYY")}</span>
              {list.space.type > 1 ? (
                <span>
                  {moment(list.book.f_hours, "HH:mm").format("HH:mm")}
                </span>
              ) : null}
              <span>{moment(list.book.f_date).format("dddd")}</span>
            </div>
            <hr />

            <div>
              <span>Check out</span>
              <b>{moment(list.book.t_date).format("DD")}</b>
              <span>{moment(list.book.t_date).format("MMM YYYY")}</span>
              {list.space.type > 1 ? (
                <span>
                  {moment(list.book.t_hours, "HH:mm").format("HH:mm")}
                </span>
              ) : null}
              <span>{moment(list.book.t_date).format("dddd")}</span>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <div>
        {isPopup ? (
          <PopupComp ref="call_pop" isPopup={this.handlePopup}>
            {isPopupStatus === "cancel" ? (
              <form onSubmit={this.handleFeedbackSubmit}>
                <div className="form-group">
                  <h2>Reason for cancelling!</h2>
                  <p>
                    Please submit the valuable reason for booking cancellation
                  </p>
                </div>
                <div className="form-group">
                  <textarea
                    name="feedback"
                    onKeyUp={this.handleFeedbackLength}
                    placeholder="Write valuable reason..."
                    required
                  ></textarea>
                  <div align="right">
                    <span id="char_length">250</span>
                    <span>&nbsp;&nbsp; Characters left</span>
                  </div>
                </div>
                <div align="right">
                  <button>Submit</button>
                </div>
              </form>
            ) : (
              <div>
                <div align="center" className="form-group">
                  <h2>{this.state.popupText1}</h2>
                  <p>{this.state.popupText2}</p>
                </div>
                <div className="confirm_btn">
                  <button onClick={() => this.handleConfirm()}>
                    <i className="fa fa-check" />
                    Yes
                  </button>
                  <button
                    type="button"
                    onClick={() => this.refs.call_pop.handleRemoveClass()}
                  >
                    <i className="fa fa-close" />
                    No
                  </button>
                </div>
              </div>
            )}
          </PopupComp>
        ) : null}

        <div className="edit-profile">
          <div className="block">
            <div className="left_" id="header_tab2">
              <div className="tab">
                <label
                  className={tab === 1 ? "active" : ""}
                  onClick={() => this.handleChange(1)}
                >
                  <i className="fa fa-user" />
                  You Made
                </label>
                <label
                  className={tab === 2 ? "active" : ""}
                  onClick={() => this.handleChange(2, "#customer")}
                >
                  <i className="fa fa-users" />
                  Customer Made
                  {count_approve > 0 ? <span>{count_approve}</span> : null}
                </label>
              </div>

              <div className="filter">
                <h3 onClick={this.handleOpenFilter}>Filter</h3>
                {show_filter ? (
                  <div>
                    <div className="filter_row">
                      <label>Sort Booking</label>
                      <select
                        onChange={e =>
                          this.handleFilterChange(e, "sortBooking")
                        }
                      >
                        <option value="">All</option>
                        {/* <option value="paid">Paid</option> */}
                        {/* <option value="done">Done</option> */}
                        <option value="cancel">Cancel</option>
                      </select>
                    </div>

                    <div className="filter_row">
                      <label>Sort Date</label>
                      <select
                        onChange={e => this.handleFilterChange(e, "sortDate")}
                        value={sortDate}
                      >
                        <option value="">All</option>
                        <option value="closest">Closest Date</option>
                      </select>
                    </div>

                    <div className="filter_row">
                      <label>Search Date</label>
                      <input type="text" placeholder="From Date" />
                      <input type="text" placeholder="To Date" />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="right_">
              {tab === 1 ? (
                <div className="space-block">
                  {!isLoading ? (
                    you_made ? (
                      you_made.map((list, i) => listing(list, i, "you_made"))
                    ) : (
                      <div>No You Made Spaces</div>
                    )
                  ) : (
                    <LoadingComp customStyle={{ padding: "200px 0" }} />
                  )}
                </div>
              ) : null}

              {tab === 2 ? (
                <div className="space-block">
                  {!isLoading ? (
                    customer_made ? (
                      customer_made.map((list, i) =>
                        listing(list, i, "customer_made")
                      )
                    ) : (
                      <div>No Customer Made Spaces</div>
                    )
                  ) : (
                    <LoadingComp customStyle={{ padding: "200px 0" }} />
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
